<template>
<div>

	<label v-for="option in extraData" style="margin-right: 25px; font-weight:normal;">
		<input type="radio" v-bind:value="option.value" v-model="currentData.value" v-on:change="check()">{{ option.text }} 
	</label>

</div>
</template>


<script>
    export default {
        props: {
	        type: {},
	        currentData: {},
	        extraData: {}
	    },
	    data: function() {

            return {

                cselect: null
               
            }

        },

        created() {

        	this.setcselect()

        },

	    methods: {
	 
	    	check() {

	    		console.log('check method in Radio.vue triggered')
	    		console.log(this.cselect);

	    		//bus.$emit('radio-changed', this.type, this.cselect)

	    		this.$emit('update')
	    	},

	    	setcselect() {

	    		if(this.currentData.value) {

	    			this.cselect = this.currentData.value;

	    		} else {
	    			this.cselect = null;
	    		}

	    	}

	    },
	    
	    watch: {

	    	currentData: function() {

	    		this.setcselect()
	    		
	    	}

	    }

    }
</script>